import styled from '@emotion/styled';

const TagsWrapper = styled('ul')({
  marginTop: 0,
  marginBottom: 0,
  marginLeft: -6,
  marginRight: -6,
  paddingLeft: 0,
  listStyle: 'none',
});

export default TagsWrapper;
